import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess204402Status: 'idle',
    startProcess204402Error: undefined as any,
    loadUserParamsProcess204402Status: 'idle',
    loadUserParamsProcess204402Error: undefined as any,

    process204402List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess204402 = createAsyncThunk('process204402Slice/startProcess204402', async ({ process204402 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess204402/`,
        prepareData(process204402),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess204402Status } = getState().process204402Slice
        return startProcess204402Status !== 'pending'
    }
})

export const loadUserParamsProcess204402 = createAsyncThunk('process204402Slice/loadUserParamsProcess204402', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess204402/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess204402Status } = getState().process204402Slice
        return loadUserParamsProcess204402Status !== 'pending'
    }
})

const Process204402Slice = createSlice({
    name: 'process204402Slice',
    initialState,
    reducers: {
        resetstartProcess204402: (state) => {
            state.job = undefined
            state.startProcess204402Error = undefined
        },
        resetstartProcess204402Error: (state) => {
            state.startProcess204402Error = undefined
        },
        resetloadUserParamsProcess204402: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess204402Error = undefined
        },
        resetloadUserParamsProcess204402Error: (state) => {
            state.loadUserParamsProcess204402Error = undefined
        },
        removeFromProcess204402ListById: (state, action) => {
            state.process204402List = state.process204402List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess204402ListByIds: (state, action) => {
            state.process204402List = state.process204402List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process204402List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess204402Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process204402List = []
            state.startProcess204402Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess204402.pending, (state) => {
            state.startProcess204402Status = 'pending'
            state.startProcess204402Error = undefined
        })
        builder.addCase(startProcess204402.fulfilled, (state, action) => {
            state.startProcess204402Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess204402.rejected, (state, action) => {
            state.startProcess204402Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess204402Error = action.error.message
            } else {
                state.startProcess204402Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess204402.pending, (state) => {
            state.loadUserParamsProcess204402Status = 'pending'
            state.loadUserParamsProcess204402Error = undefined
        })
        builder.addCase(loadUserParamsProcess204402.fulfilled, (state, action) => {
            state.loadUserParamsProcess204402Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess204402.rejected, (state, action) => {
            state.loadUserParamsProcess204402Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess204402Error = action.error.message
            } else {
                state.loadUserParamsProcess204402Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess204402,
    resetstartProcess204402Error,
    resetloadUserParamsProcess204402,
    resetloadUserParamsProcess204402Error,
    removeFromProcess204402ListById,
    removeFromProcess204402ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process204402Slice.actions
export default Process204402Slice.reducer
